import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (item: EntityBase) => void;
}): TableColumn<EntityBase>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'name',
      label: 'Должность',
      options: {
        filter: {
          name: 'name',
          type: 'text',
        },
        sort: false,
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton name="edit" onClick={() => onEdit(rowData)} aria-label="edit" size='sm'>
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    },
    {
      name: 'is_active',
      label: 'Активность',
      options: {
        hidden: true,
        filter: {
          name: 'is_active',
          type: 'boolean',
        },
        sort: false,
      },
    }
  ];
};